<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-column gap-3">
    <eo-form-panel
      *ngFor="let c of getConfig()"
      [formGroup]="c.getFormGroupFromForm(form)"
      [customFormControls]="customFormControls"
      [config]="c"
    />
    @if (isSubmitButtonVisible()) {
      <div
        [class]="getSubmitButtonDivStyleClass()"
      >
        <p-button
          type="submit"
          [label]="getSubmitButtonLabel()"
          [styleClass]="getSubmitButtonStyleClass()"
          [disabled]="isSubmitButtonDisabled()"
          [loading]="isSubmitButtonLoading()"
          [icon]="getIcon()"
        />
      </div>
    }

  </div>
  <button type="submit" style="display: none;"></button>
</form>
